// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"595":"9d8a9ebb","734":"7d9d1aa1","2493":"2e8da5f4","3717":"9d8a9ebb"}[chunkId] + ".chunk.css";
};